import React from 'react';
import Slider from 'react-slick';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';

import 'app/assets/stylesheets/about_hiring/carousel.scss';

type Slide = {
  image: string;
  alt: string;
  label?: {
    imageDescription?: string;
    name?: string;
    title?: string;
    links?: {
      linkedin?: string;
    };
  };
};

type Props = {
  slides: Slide[];
  size: 'small' | 'large';
  format: 'centered' | 'left-aligned';
};

const Carousel: React.FC<Props> = ({ slides, size, format }) => {
  return (
    <Slider
      slidesToShow={1}
      infinite
      draggable={false}
      centerMode={format === 'centered'}
      centerPadding="0px"
      dots
      variableWidth
      className={classNames(`slider-size-${size}`, `slider-format-${format}`)}
    >
      {slides.map(({ image, alt, label }) => (
        <div key={image}>
          <img src={image} alt={alt} />
          {label?.imageDescription && (
            <div className="slide-description">{label.imageDescription}</div>
          )}
          {label?.name && <div className="slide-name">{label.name}</div>}
          {label?.title && <div className="slide-title">{label.title}</div>}
          {label?.links && (
            <div className="slide-links">
              {label.links.linkedin && (
                <a
                  href={label.links.linkedin}
                  target="_blank"
                  className="slide-link-linkedin"
                >
                  <FontAwesomeIcon color="black" icon={faLinkedin} />
                </a>
              )}
            </div>
          )}
        </div>
      ))}
    </Slider>
  );
};

export default Carousel;
